export class PONumbersDropDownDto {
    poNumber: string;
    saleOrderId?: number;

    /**
     * 
     * @param saleOrderId 
     * @param poNumber 
     */
    constructor(poNumber: string,saleOrderId?: number){ 
        this.poNumber = poNumber
        this.saleOrderId = saleOrderId
        }
    }